module.exports = __webpack_public_path__ + "img/ic_user Log.716c9f8d.svg";